<template>
  <div>
    <vs-alert
      v-if="$validator.errors.all().length > 0"
      color="danger"
      title="Atenção!!"
      active="true"
      class="my-3"
      style="height: auto !important"
    >
      <ul>
        <li
          class="mb-2"
          v-for="error in $validator.errors.all()"
          :key="error.id"
        >
          {{ error }}
        </li>
      </ul>
    </vs-alert>
    <form role="form" @submit.stop.prevent="prevet">
      <h4 class="mb-3 mt-5">Selecione o Tipo de Foto</h4>
      <div class="vx-row img">
        <div class="vx-col containerimg sm:w-1/2 w-1/2 mb-2 mt-4">
          <v-select
            :options="this.filtraFotosPorPermissoes(fotos)"
            label="nomePosicao"
            name="tipo"
            v-model="formCadastro.foto"
            @input="selecionaSelectTipoFoto"
            data-testId="upload-image-select"
          ></v-select>
          <vs-alert
            v-if="urlArquivoServidor"
            color="warning"
            title="Atenção!"
            active="true"
            class="my-3"
            style="height: auto !important"
            >Ao fazer o upload manual, este arquivo atual será substituído.
          </vs-alert>
          <vs-textarea
            v-if="this.tipoFoto == 'Vistoria'"
            class="mt-6"
            label="Observações"
            v-model="formCadastro.observacaoVistoria"
            id="observacao"
            data-testId="obs-textarea"
          />
        </div>
        <div class="vx-col containerimg sm:w-1/2 w-1/2 mb-2 text-center mt-4">
          <center>
            <div v-if="extensaoArquivo == 'mp4' && urlArquivoServidor">
              <video
                class="video"
                controls
                muted
                loop
                :src="urlArquivoLocal ? urlArquivoLocal : urlArquivoServidor"
              ></video>
            </div>
            <div v-if="extensaoArquivo == 'pdf'">
              <img
                src="../../../src/assets/images/elements/PDF_file_icon2.png"
                width="100%"
                style="max-width: 150px"
              />
              <p>
                {{
                  extensaoArquivo == 'pdf' && urlArquivoLocal
                    ? nomeArquivo
                    : urlArquivoServidor.split('/').pop()
                }}
              </p>

              <p></p>
            </div>

            <div
              v-if="
                extensaoArquivo == 'jpeg' ||
                extensaoArquivo == 'jpg' ||
                extensaoArquivo == 'png' ||
                extensaoArquivo == 'gif'
              "
            >
              <img
                :src="urlArquivoLocal ? urlArquivoLocal : urlArquivoServidor"
                width="100%"
                style="max-width: 250px"
              />
            </div>
          </center>
          <input
            id="fileUpload"
            type="file"
            accept="video/*,image/*,.pdf"
            hidden
            v-on:change="selecionaFotoUpload"
            data-testId="file-upload-input"
          />
          <vs-button
            color="warning"
            type="border"
            class="text-center"
            @click="chooseFiles()"
            :disabled="disableChooseButton"
            data-testId="choose-file-button"
          >
            Escolher um Arquivo
            <feather-icon icon="UploadIcon" class="ml-2" />
            <Br />
            <vs-chip v-if="nomeArquivo" class="mt-3">
              <vs-avatar icon-pack="feather" icon="icon-file" />
              <span>{{ nomeArquivo }}</span>
            </vs-chip>
          </vs-button>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full text-right mt-5">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            data-testId="cancel-button"
            >Cancelar
          </vs-button>
          <vs-button
            color="success"
            class="mr-3 mb-2"
            @click="onSubmit"
            :disabled="disableSubmitButton"
            data-testId="save-button"
            >Salvar Alterações
          </vs-button>
          <div v-if="showProgressBar == true">
            <span>Carregando... por favor, aguarde.</span>
            <vs-progress
              :height="8"
              :percent="progressPercentage"
              color="primary"
              >primary
            </vs-progress>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import io from 'socket.io-client';
import locale from './../../locale';
import * as lang from 'vuejs-datepicker/src/locale';
import service from '../../services';
import vSelect from 'vue-select';

export default {
  props: ['fotos', 'idProposta'],
  data() {
    return {
      extensaoArquivo: null,
      progressPercentage: null,
      showProgressBar: false,
      tamanhoParcialArquivoAcumulado: null,
      tamanhoParcialArquivo: null,
      tamanhoTotalArquivoLocal: null,
      reqQuery: null,
      urlArquivoLocal: null,
      arquivoLocal: null,
      disableChooseButton: true,
      disableSubmitButton: true,
      aguardeCadastro: false,
      urlArquivoServidor: null,
      fotoAtual: 0,
      currentPage: 1,
      pageCount: 0,
      hasImage: false,
      files: new FormData(),
      image: null,
      languages: lang,
      tipoFoto: null,
      nomeArquivo: null,
      nomeRegulamento: null,
      funcoesValicao: null,
      subjectPermission: 'Vistorias',
      formCadastro: {
        observacaoVistoria: null,
        idEmpresa: null,
        foto: null,
        idProposta: null,
      },
      socket: null,
    };
  },
  methods: {
    prevet() {
      return;
    },
    selecionaSelectTipoFoto(item) {
      if (!this.formCadastro.foto) {
        this.urlArquivoLocal = null;
        this.nomeArquivo = null;
        this.disableSubmitButton = true;
        this.disableChooseButton = true;
        this.urlArquivoServidor = null;
        this.extensaoArquivo = null;
        return;
      }
      this.urlArquivoLocal = null;
      this.urlArquivoServidor = item.nome;
      this.extensaoArquivo = null;
      this.tipoFoto = null;
      this.nomeArquivo = null;
      this.formCadastro.observacaoVistoria = item.observacaoVistoria;
      this.tipoFoto = item.tipoFoto;
      this.formCadastro.idProposta = this.idProposta;

      if (this.formCadastro.foto) this.disableChooseButton = false;

      this.verificaExtensaoArquivo();
    },
    selecionaFotoUpload(event) {
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;

      this.arquivoLocal = files;
      this.tamanhoTotalArquivoLocal = this.arquivoLocal[0].size;
      this.urlArquivoLocal = URL.createObjectURL(this.arquivoLocal[0]);

      if (this.arquivoLocal) this.disableSubmitButton = false;

      this.files.set('file', event.target.files[0], event.target.files[0].name);
      this.formCadastro.idProposta = this.idProposta;
      this.nomeArquivo = files[0].name;

      this.verificaExtensaoArquivo();
    },
    successUpload() {
      this.$vs.notify({
        color: 'success',
        title: 'Upload Success',
        text: 'Lorem ipsum dolor sit amet, consectetur',
      });
    },
    chooseFiles() {
      document.getElementById('fileUpload').click();
    },
    chooseFiles2() {
      document.getElementById('fileUpload2').click();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    startImageResize() {
      this.carregando = true;
    },
    endImageResize() {
      this.carregando = false;
    },
    setImage: function (output) {
      this.necessitaUpload = true;
      this.hasImage = true;
      this.image = output;
      this.imgUrl = output.dataUrl;

      var blob = canvasToBlob(this.imgUrl);
      this.image.blob = blob;
      this.styleFoto = 'display:none';

      this.verificaExtensaoArquivo();
    },
    verificaExtensaoArquivo() {
      if (this.urlArquivoLocal) {
        const ext = this.nomeArquivo.split('.').pop();
        this.extensaoArquivo = ext;
        this.tipoFoto = ext;
        return true;
      }

      if (this.urlArquivoServidor && !this.urlArquivoLocal) {
        const ext = this.urlArquivoServidor.split('.').pop();
        this.extensaoArquivo = ext;
        this.tipoFoto = ext;
        return true;
      }
      return false;
    },
    onSubmit() {
      if (this.formCadastro.foto == null) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Selecione o Tipo de Foto Corretamente`,
          color: 'danger',
        });
        return;
      }

      this.formCadastro.isUpload = true;
      this.showProgressBar = true;
      this.disableSubmitButton = true;
      this.disableChooseButton = true;

      service
        .upload(
          'upload-v2',
          'Vistoria/' + this.idProposta + `?room=${this.reqQuery}`,
          this.files,
        )
        .then((response) => {
          this.formCadastro.url = response.urlImage;
          this.urlArquivoServidor = response.urlImage;

          this.$validator.validateAll().then((result) => {
            if (result) {
              this.aguardeCadastro = true;
              // this.$vs.loading();
              this.showProgressBar = true;
              this.disableSubmitButton = true;
              service
                .post(
                  'Cotacao',
                  'AtualizaFotoVistoriaUpload',
                  this.formCadastro,
                )
                .then(() => {
                  this.aguardeCadastro = false;
                  // this.$vs.loading.close();
                  this.showProgressBar = false;
                  this.disableSubmitButton = false;
                  this.$vs.notify({
                    position: 'top-center',
                    title: 'Atenção',
                    text: 'Dados Atualizados com sucesso',
                    color: 'success',
                  });
                  this.$emit('uploaded', true);
                  this.formCadastro = {
                    idEmpresa: null,
                    foto: null,
                    idProposta: null,
                    observacaoVistoria: null,
                  };
                  this.nomeArquivo = null;
                  this.progressPercentage = null;
                  this.tamanhoParcialArquivo = null;
                  this.tamanhoParcialArquivoAcumulado = null;
                  this.urlArquivoLocal = null;
                  this.urlArquivoServidor = null;
                  this.extensaoArquivo = null;
                })
                .catch(() => {
                  this.aguardeCadastro = false;
                  this.showProgressBar = false;
                  this.disableSubmitButton = false;
                  // this.$vs.loading.close();
                  this.$vs.notify({
                    position: 'top-center',
                    title: 'Atenção',
                    text: 'Não foi possível atualizar os Dados',
                    color: 'danger',
                  });
                });
            }
          });

          this.$vs.loading.close();
          //this.onSubmit();
        })
        .catch(function (e) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    onReset(evt) {
      evt.preventDefault();
      (this.disableChooseButton = true),
        (this.disableSubmitButton = true),
        (this.formCadastro = {
          idEmpresa: null,
          foto: null,
          idProposta: null,
        });
      this.urlArquivoServidor = null;
      this.urlArquivoLocal = null;
      this.extensaoArquivo = null;
      this.tipoFoto = null;
      this.nomeArquivo = null;
      this.$nextTick(() => {
        this.show = true;
      });
      this.$emit('fechaModalUploadManual');
    },
    calculatePercentage(totalValue, actualValue) {
      const percentage = (100 * actualValue) / totalValue;
      this.progressPercentage = percentage;
      return parseInt(this.progressPercentage);
    },
    connectWebSocket() {
      this.socket = io(process.env.VUE_APP_SERVER_SOCKET);
      this.socket.on('message', (res) => {
        if (res.length) {
          this.tamanhoParcialArquivo = res.length;

          this.tamanhoParcialArquivoAcumulado =
            this.tamanhoParcialArquivoAcumulado + this.tamanhoParcialArquivo;

          this.progressPercentage = this.calculatePercentage(
            this.tamanhoTotalArquivoLocal,
            this.tamanhoParcialArquivoAcumulado,
          );
        }
      });
      this.socket.on('join_room_response', () => {
        const dateTime = Date.now();
        this.files.set(
          'query',
          `upload-vistoria-${this.idProposta}-room${dateTime}`,
        );
      });
      this.socket.on('connect_error', (err) => {
        console.error(err);
      });
      this.socket.on('connect', () => {
        const dateTime = Date.now();
        this.reqQuery = `upload-vistoria-${this.idProposta}-room${dateTime}`;
        this.socket.emit('join_room', this.reqQuery);
      });
    },
    filtraFotosPorPermissoes(arrayFotos) {
      if (this.$can('Upload Manual Completo', this.subjectPermission)) {
        return arrayFotos;
      } else if (
        this.$can('Upload Manual Documentação', this.subjectPermission)
      ) {
        const fotosFiltradas = arrayFotos.filter(
          (foto) => foto.tipoFoto == 'Documentação',
        );
        return fotosFiltradas;
      } else {
        return [];
      }
    },
  },
  created() {
    this.$validator.localize('ptBr', locale);
  },
  mounted() {
    this.connectWebSocket();
  },
  destroyed() {
    if (this.socket) {
      this.socket.disconnect();
    }
  },
  components: {
    vSelect,
  },
};
</script>
<style>
#fileInput {
  display: none;
}

.img label {
  width: 100%;
  font-weight: normal;
}

.img .containericone {
  text-align: center;
  border-radius: 10px;
  padding: 10px 20px;
  -webkit-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  width: min-content;
  margin-top: 25px;
  margin-left: 43%;
  border: 1px solid #ccc;
}

.video {
  max-height: 140px;
}

@media (max-width: 1100px) {
  .video {
    max-height: 100px !important;
  }
}

@media (max-width: 1395px) {
  .video {
    max-height: 90px !important;
  }
}

.img .icone {
  font-size: 50px;
  color: #333;
}
</style>
